/*
 * @Author: 吴紫阳 764401855@qq.com
 * @Date: 2022-09-21 14:47:46
 * @LastEditors: 吴紫阳 764401855@qq.com
 * @LastEditTime: 2022-10-10 17:05:02
 * @FilePath: \pit-bimwin-react-ui\src\components\PitModule\sectioning.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, {
  FC,
  // CSSProperties,
  // memo,
  // useCallback,
  // useRef,
  // useEffect,
} from 'react';
interface PitModuleSectioningProps {}
const PitModuleSectioning: FC<PitModuleSectioningProps> = () => {
  return <div>1</div>;
};
export default PitModuleSectioning;
